export default __webpack_public_path__ + "static/media/store.84df6c92.svg";